module.exports = __webpack_public_path__ + "img/banner.80c369bc.jpg";